module.exports = __webpack_public_path__ + "static/media/1_pl.fe95a07e.png";